import { useLocation } from "react-router-dom";

const steps = [
  { title: "Personal Details", url: "/joint-personal-details" },
  { title: "Employment Details", url: "/joint-employment-details" },
  { title: "Income Details", url: "/joint-income-details" },
  {
    title: "Assets & Liabilities",
    url: "/joint-assets-liabilities",
  },
  { title: "Declaration & Signatures", url: "/joint-signatures" },
];

const JointStepper = () => {
  const { pathname } = useLocation();
  const activeIndex = steps.findIndex((step) => pathname.startsWith(step.url));

  return (
    <div className="mt-4 mb-2 ">
      {/* Desktop View */}
      <div className="hidden xl:flex items-center justify-center gap-8">
        {steps.map((step, index) => (
          <button
            key={index}
            className={`px-5 py-3 rounded-full border transition-all font-Mulish text-base font-normal relative
              ${
                index === activeIndex
                  ? "bg-[#D1A960] text-white animate-pulse-wave"
                  : index < activeIndex
                  ? "bg-[#D1A960] text-white"
                  : "border-[#EAECF0] text-lightBlue  cursor-not-allowed"
              }`}
          >
            {step.title}
          </button>
        ))}
      </div>

      {/* Mobile View */}
      <div className="flex xl:hidden justify-between items-center  px-2">
        {steps.map((step, index) => (
          <div key={index}>
            {index === activeIndex ? (
              <button className="px-5 py-2 rounded-full bg-[#D1A960] text-white font-medium text-sm">
                {step.title}
              </button>
            ) : (
              <div
                className={`w-4 h-4 rounded-full ${
                  index < activeIndex ? "bg-[#D1A960]" : "bg-[#EAECF0]"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default JointStepper;
